import { Image } from 'react-native';

import Images, { TImages } from '../../Images';

const images = {
  ...Images,
  TImages,

  ic_close: Image.resolveAssetSource(require('./../../../Assets/Images/Icons/icClose@3x.png')),
  ic_arrow_left: Image.resolveAssetSource(
    require('./../../../Assets/Images/Icons/icArrowLeft@3x.png'),
  ),
  header_image_overlay: Image.resolveAssetSource(
    require('../../../Assets/Images/HeaderOverlays/lightOverlay@3x.png'),
  ),
  ic_v_home_monitor: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icVHomeMonitorWhite@3x.png'),
  ),
  ic_alarm_assistant: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/alarmAssistantWhite@3x.png'),
  ),
  ic_video_cloud: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icVideoCloudLight@3x.png'),
  ),
  ic_mobiles: Image.resolveAssetSource(require('../../../Assets/Images/Icons/icMobiles@3x.png')),
  ic_warning_mid: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icWarningMid@3x.png'),
  ),
  ic_warning_mid_active: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icWarningNotificationUiredActive@3x.png'),
  ),
  icPadlockClose: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icPadlockClose@3x.png'),
  ),
  ic_chevron_right_red: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icChevronRightRed@3x.png'),
  ),
  ic_chevron_right: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icChevronRightRed@3x.png'),
  ),
  ic_chevron_down: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icChevronDown@3x.png'),
  ),
  ic_chevron_up: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/ic_chevron_up@3x.png'),
  ),
  ic_chevron_up_red: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/ic_chevron_up_red@3x.png')
  ),
  ic_tick_solved: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icTickSolved.png'),
  ),
  ic_indicators_admin: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/iconsIndicatorsSystemIconsAdmin333333@3x.png'),
  ),
  ic_indicators_business: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/iconsIndicatorsSystemIconsBusiness333333@3x.png'),
  ),
  ic_indicators_home: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/iconsIndicatorsSystemIconsHome333333@3x.png'),
  ),
  ic_indicators_family: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icFamily@3x.png'),
  ),
  ic_close_circle: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icCloseCircle@3x.png'),
  ),
  ic_close_circle_white: Image.resolveAssetSource(
    require('../../../Assets/Images/Icons/icCloseCircle@3x.png'),
  ),
  ic_user: Image.resolveAssetSource(require('../../../Assets/Images/Icons/icUser@3x.png')),
  ic_share: Image.resolveAssetSource(require('../../../Assets/Images/Icons/icShare@3x.png')),
};

export default images;
